import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppServices } from './../../app.services';
import { NotifyService } from './../../addon/notify.service';
import { GravatarService } from './../../addon/gravatar.service';
import { FirebaseService } from './../../addon/firebase.service';

import * as _ from 'lodash';

declare var $:any;

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
	constructor(private router: Router, private appServices: AppServices, private notifyService: NotifyService
		, private gravatarService: GravatarService, private firebaseService: FirebaseService) { }

	ngOnInit() {
	}
	doSignup(data) {
		data = Object.assign(data, {
			'accountcode': this.appServices.accountcode
		});
		this.gravatarService.getLink(data['email'], (gravatar) => {
			data['photo'] = gravatar;
			this.appServices.api('Members/signup', data, this).then(function(obj){
				let res = obj.response.json().res;
				obj.component.appServices.session = [];
				obj.component.appServices.session.push({
					'member': res
				});
				obj.component.router.navigate(['/main/profile/', res.code]);
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');
			})
		});
	}
	doSignin(data) {
		data = _.pickBy(data);
		this.appServices.api('Members/signin', data, this).then(function(obj){
			let res = obj.response.json().res;
			if(res.member && res.member.length > 0) {
				obj.component.appServices.session = [];
				obj.component.appServices.session.push({
					'member': res.member[0]
				});
				obj.component.appServices.headers.append('token', res.token.id);
				obj.component.appServices.headers.append('uid', res.token.uid);
				obj.component.router.navigate(['/main/profile/', res.member[0].code]);
				obj.component.appServices.accountcode = res.member[0].accountcode;
				obj.component.fcm(res.member[0])
			} else {
				obj.component.notifyService.show(res, 'danger');
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	doForget(data) {
		this.appServices.api('Members/forget', {
			'email': data.email
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.notifyService.show(obj.response.statusText);
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	fcm(member) {
		this.firebaseService.getToken((token) => {
			this.appServices.api('Members/save', {
				'code': member.code,
				'fcm': token
			}, this).then(function(obj){
				let res = obj.response.json().res;
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');
			});
		})
	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/main/home/home.component.ts